import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[zefSidenavTitle]',
  standalone: false,
})
export class SidenavTitle {
  readonly tr = inject<TemplateRef<any>>(TemplateRef);
}
